<template>
  <div class="notfound">
        <b-container fluid >
            <b-row class="h-100">
                <b-col cols="12" md="4" class="pl-5 leftcontent" >
                    <h6 class="my-0" style="color: grey"> Oops! Not Found </h6>                      
                    <br>                                      
                    <b-button squared variant="outline-dark" class="mt-3 shadow"  @click="goBack"> {{ $t('common.goback') }}</b-button>  
                    <!-- <appt-button v-bind:color="'d'"/>    -->
                </b-col>
  

           </b-row>

        </b-container>
  </div>
</template>

<script>

export default {
  name: 'notfound',
  data () {
    return {
      data:''
    } 
  },
  methods: {
    getImgUrl(p) {
        var images = require.context('../assets/images/', false, /\.jpg$/)
        return images('./' + p + ".jpg")
  },
    goBack (){
      this.$router.go(-1)
  },
  },

  computed: {
      locale(){
          return this.$i18n.locale
      },
  },


  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.card-img {
    width: 100%;
    max-height: 300px;
    object-fit: cover;
}
.mycontainer-main {
    min-height:  80vh;
}


.main-button {
    min-width: 175px;
    text-transform: uppercase;
}
.leftcontent {
    padding-top: 30vh;
    padding-bottom: 10vh;
}

</style>



// WEBPACK FOOTER //
// src/pages/NotFound.vue